import { ResidentialRentComp } from 'types/underwriting/income-approach';
import { compplexGraphqlApiUrl } from 'utils/config';

export const COMPPLEX_RESIDENTIAL_LEASE_BY_ID_AND_VERSION = `
      query findResidentialLeaseByIdAndVersion($input: ResidentialLeaseSearchByVersionInput!) {
        findResidentialLeaseByIdAndVersion(input: $input) {
          isLatestVersion
          deletedAt
        }
      }
    `;

const checkIfLatestResidentialRentCompVersion = async (input: { leaseId: string; version: number }) => {
  if (!compplexGraphqlApiUrl) {
    throw new Error('COMPPLEX_GRAPHQL_API_URL is not defined');
  }

  const response = await fetch(compplexGraphqlApiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: COMPPLEX_RESIDENTIAL_LEASE_BY_ID_AND_VERSION,
      variables: { input },
      fetchPolicy: 'no-cache',
    }),
  });

  const data = await response.json();

  return data?.data.findResidentialLeaseByIdAndVersion || { isLatestVersion: false };
};

export const checkIfResidentialRentCompsAreLatestVersion = async (selectedComps: ResidentialRentComp[]) => {
  const updates = selectedComps.map(async (residentialRentComp) => {
    const { leaseId, leaseVersionNumber } = residentialRentComp;
    const { isLatestVersion } = leaseVersionNumber
      ? await checkIfLatestResidentialRentCompVersion({
          version: leaseVersionNumber,
          leaseId,
        })
      : { isLatestVersion: false };

    return {
      ...residentialRentComp,
      isLatestVersion,
    };
  });

  const updatedComps = await Promise.all(updates);
  return updatedComps;
};
